/* Closed state, reopen and the post-close retry. Tokens only (ADR-0007). */
.state {
  display: grid;
  gap: 4px;
  margin: 0 0 10px;
}

.closed {
  margin: 0;
  font-size: var(--t-dense);
  color: var(--ink);
}

.hint {
  margin: 0 0 6px;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.55;
  max-width: 92ch;
}

.hint strong {
  color: var(--ink-2);
}

/* Amber because a person reading a filing has to know the inventory moved under it. */
.flag {
  margin: 0 0 6px;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--warn);
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.55;
  max-width: 92ch;
}

.flag strong {
  color: var(--warn);
}

.done {
  margin: 0 0 6px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.form {
  display: grid;
  gap: 6px;
  max-width: 92ch;
}

.field {
  display: grid;
  gap: 4px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink-2);
}

.field textarea,
.field input {
  padding: 6px 9px;
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 400;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 6px;
  min-width: 0;
}

.field textarea:focus-visible,
.field input:focus-visible {
  border-color: var(--focus);
  outline: 2px solid var(--focus);
  outline-offset: 0;
}

.counter {
  font-size: var(--t-min);
  font-weight: 400;
  color: var(--muted);
  font-variant-numeric: lining-nums tabular-nums;
}

.secondary {
  justify-self: start;
  padding: 5px 11px;
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  line-height: 18px;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 6px;
  cursor: pointer;
}

.secondary:hover:not(:disabled) {
  color: var(--accent);
  border-color: var(--accent);
}

.secondary:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.refusal {
  display: grid;
  gap: 6px;
  margin: 8px 0 0;
  padding: 6px 0 6px 10px;
  border-left: 2px solid var(--warn);
  font-size: var(--t-min);
  line-height: 1.55;
  color: var(--ink-2);
  max-width: 92ch;
}

.refusalHead {
  color: var(--ink);
}

.periods {
  margin: 0;
  padding-left: 18px;
}

.act {
  display: grid;
  gap: 6px;
}

.history {
  font-size: var(--t-min);
  color: var(--ink-2);
}

.history ol {
  margin: 4px 0 0;
  padding-left: 18px;
}

.eventReason {
  display: block;
  color: var(--muted);
}
